import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import AttendanceChart from '../../Model/Individual/StatisticsModel/AttendanceChart';

import IntroMarkdown from './IntroMarkdown';

export default function AttendanceChartRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const { intro, chartData, viewMode, attendanceRate, attendedCount, isCountOncePerDay } = data;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <HeaderRow>
        <HeaderLeft>
          <Text fontFamily='NotoSansKR-Medium' fontSize={18} $color={theme.text}>
            {viewMode === 'monthly' ? t('statistics.attendance.monthlyAverageAttendanceRate') : t('statistics.attendance.dailyAverageAttendanceRate')}
          </Text>
          <Text fontFamily='NotoSansKR-Bold' fontSize={18} $color={theme.subKey}>
            {attendanceRate}%
          </Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={18} $color={theme.subKey}>
            [{t('statistics.attendance.average') + ' ' + attendedCount + t('statistics.attendance.attendedSuffix')}]
          </Text>
        </HeaderLeft>
      </HeaderRow>
      <ChartContainer $color={theme.subBackground}>
        <AttendanceChart
          chartData={chartData}
          viewMode={viewMode || 'daily'}
          isCountOncePerDay={isCountOncePerDay !== undefined ? isCountOncePerDay : true} />
      </ChartContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  padding: 0 4px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.$color};

  margin: 0 0 0 0;
`;

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  overflow-x: auto;

  border-radius: 20px;
  background-color: ${props => props.theme.subBackground};
`;
